
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitmentagency",
      function () {
        return require("private-next-pages/recruitmentagency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitmentagency"])
      });
    }
  